import React from "react";
import "./style.scss";
import Logo from "assets/logo_blue.svg";

export const MainLogo = () => {
  return (
    <>
      <div className="mainLogo">
        <img src={Logo} alt="Logo" />
      </div>
    </>
  );
};
